export default {
  name: `rotate_screen`,
  cta: `폰을 돌려주세요`,
};
